import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b25e1b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-xl text-center" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = {
  key: 0,
  class: "text-field"
}
const _hoisted_4 = {
  key: 1,
  class: "check-box"
}
const _hoisted_5 = {
  key: 2,
  class: "drop-down input-group"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "label-text" }
const _hoisted_8 = { class: "custom-sign-up-tooltip-wrap" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["id", "name", "data-cy"]
const _hoisted_11 = ["label", "value"]
const _hoisted_12 = { class: "radio-group" }
const _hoisted_13 = { class: "small" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = {
  href: "https://www.teladochealth.com/terms-of-service/",
  target: "_blank"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_InlineError = _resolveComponent("InlineError")!
  const _component_BaseInputCheckbox = _resolveComponent("BaseInputCheckbox")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Birthdate = _resolveComponent("Birthdate")!
  const _component_BaseInputRadio = _resolveComponent("BaseInputRadio")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_MHForm = _resolveComponent("MHForm")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, { size: "sm" }, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('heading')), 1),
      _createVNode(_component_MHForm, { ref: "form" }, {
        default: _withCtx(({ handleSubmit, meta }) => [
          _createElementVNode("form", {
            class: "account-form",
            onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.saveUser)), ["prevent"])
          }, [
            _createVNode(_component_BaseInputText, {
              ref: "firstNameInput",
              "data-cy": "first-name-input",
              maxlength: "50",
              labelLocation: "top",
              validationRules: _ctx.CommonRules.VALID_NAME,
              labelText: _ctx.$t('form.firstNameField.label'),
              inputName: _ctx.$t('form.firstNameField.name'),
              inputModel: _ctx.firstName,
              "onUpdate:inputModel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.firstName = $event))
            }, null, 8, ["validationRules", "labelText", "inputName", "inputModel"]),
            _createVNode(_component_BaseInputText, {
              "data-cy": "last-name-input",
              maxlength: "50",
              labelLocation: "top",
              validationRules: _ctx.CommonRules.VALID_NAME,
              labelText: _ctx.$t('form.lastNameField.label'),
              inputName: _ctx.$t('form.lastNameField.name'),
              inputModel: _ctx.lastName,
              "onUpdate:inputModel": _cache[1] || (_cache[1] = ($event: any) => (_ctx.lastName = $event))
            }, null, 8, ["validationRules", "labelText", "inputName", "inputModel"]),
            _createVNode(_component_BaseInputText, {
              "data-cy": "screen-name-input",
              maxlength: "50",
              validationRules: "required",
              labelLocation: "top",
              labelText: _ctx.$t('form.screenNameField.label'),
              inputName: _ctx.$t('form.screenNameField.name'),
              labelSubText: _ctx.$t('form.screenNameField.subtext'),
              inputModel: _ctx.alias,
              "onUpdate:inputModel": _cache[2] || (_cache[2] = ($event: any) => (_ctx.alias = $event))
            }, null, 8, ["labelText", "inputName", "labelSubText", "inputModel"]),
            _createVNode(_component_BaseInputText, {
              "data-cy": "email-input",
              labelLocation: "top",
              validationRules: "email|required",
              labelText: _ctx.$t('form.emailField.label'),
              inputName: _ctx.$t('form.emailField.name'),
              inputModel: _ctx.email,
              "onUpdate:inputModel": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email = $event))
            }, null, 8, ["labelText", "inputName", "inputModel"]),
            _createVNode(_component_BaseInputText, {
              "data-cy": "password-input",
              "input-type": "password",
              labelLocation: "top",
              validationRules: "required|upperCase|lowerCase|oneNumber|min:8",
              labelText: _ctx.$t('form.passwordField.label'),
              inputName: _ctx.$t('form.passwordField.name'),
              labelSubText: _ctx.$t('form.passwordField.subText'),
              inputModel: _ctx.password,
              "onUpdate:inputModel": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event))
            }, null, 8, ["labelText", "inputName", "labelSubText", "inputModel"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountSetupFields, (aField) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "custom-field-wrapper",
                key: aField.name
              }, [
                (aField.type === _ctx.SignUpFieldType.TEXT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_BaseInputText, {
                        "data-cy": `custom-input-${aField.name}`,
                        inputName: aField.name,
                        labelText: aField.label,
                        inputModel: _ctx.customFields[aField.name],
                        validationRules: _ctx.fieldValidationRules(aField),
                        tooltipHTML: aField.helpTooltip,
                        "onUpdate:inputModel": ($event: any) => (_ctx.customFields[aField.name] = $event)
                      }, null, 8, ["data-cy", "inputName", "labelText", "inputModel", "validationRules", "tooltipHTML", "onUpdate:inputModel"])
                    ]))
                  : (aField.type === _ctx.SignUpFieldType.CHECK_BOX)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_BaseInputCheckbox, {
                          key: "customCheckbox",
                          "data-cy": `custom-checkbox-${aField.name}`,
                          inputName: aField.name,
                          labelText: aField.label,
                          inputModel: _ctx.customFields[aField.name],
                          "validation-rules": _ctx.checkboxValidationRules(aField),
                          tooltipHTML: aField.helpTooltip,
                          "onUpdate:inputModel": ($event: any) => (_ctx.customFields[aField.name] = $event)
                        }, {
                          "error-message": _withCtx(() => [
                            _createVNode(_component_InlineError, {
                              "data-cy": "custom-checkbox-errors",
                              message: aField.validationFailureText || _ctx.$t('form.requiredValidationFailure')
                            }, null, 8, ["message"])
                          ]),
                          _: 2
                        }, 1032, ["data-cy", "inputName", "labelText", "inputModel", "validation-rules", "tooltipHTML", "onUpdate:inputModel"])
                      ]))
                    : (aField.type === _ctx.SignUpFieldType.DROP_DOWN)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("label", {
                            for: aField.name
                          }, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(aField.label), 1),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_Tooltip, { class: "custom-sign-up-tooltip" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "content",
                                    innerHTML: aField.helpTooltip
                                  }, null, 8, _hoisted_9)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ], 8, _hoisted_6),
                          _createVNode(_component_Field, {
                            class: "validation-provider",
                            rules: _ctx.requiredField(aField),
                            name: aField.name,
                            modelValue: _ctx.customFields[aField.name],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.customFields[aField.name]) = $event)
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createElementVNode("select", _mergeProps(field, {
                                id: aField.name,
                                name: aField.name,
                                "data-cy": `custom-dropdown-${aField.name}`
                              }), [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aField.choices, (choice) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    label: choice.label,
                                    key: choice.label,
                                    value: choice.value
                                  }, _toDisplayString(choice.label), 9, _hoisted_11))
                                }), 128))
                              ], 16, _hoisted_10),
                              (errors[0])
                                ? (_openBlock(), _createBlock(_component_InlineError, {
                                    key: 0,
                                    "data-cy": "account-setup-select-errors",
                                    message: errors[0]
                                  }, null, 8, ["message"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["rules", "name", "modelValue", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createVNode(_component_Birthdate, {
              isSubjectToGdpr: _ctx.isSubjectToGdpr,
              inputModel: _ctx.dateOfBirth,
              onIsValid: _ctx.setBirthDateValid,
              onMinimumAge: _ctx.setMinimumAge,
              "onUpdate:inputModel": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateOfBirth = $event))
            }, null, 8, ["isSubjectToGdpr", "inputModel", "onIsValid", "onMinimumAge"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('form.gender.title')), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('form.gender.inline')), 1),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderOptions, (genderItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "column",
                    key: index
                  }, [
                    _createVNode(_component_BaseInputRadio, {
                      inputName: "gender",
                      inputModel: _ctx.gender,
                      inputId: `gender-${index}`,
                      value: genderItem,
                      labelText: _ctx.$t(`form.gender.options['${genderItem}']`),
                      "data-cy": `${genderItem.toLowerCase()}-radio`,
                      "onUpdate:inputModel": _cache[6] || (_cache[6] = ($event: any) => (_ctx.gender = $event))
                    }, null, 8, ["inputModel", "inputId", "value", "labelText", "data-cy"])
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_15,
            _createVNode(_component_BaseInputCheckbox, {
              "data-cy": "age-checkbox",
              key: "age",
              inputName: "validAge",
              "validation-rules": "required",
              labelText: _ctx.$t('form.validAgeCheckbox.label', {minAge: _ctx.minimumAge}),
              inputModel: _ctx.isValidAge,
              "onUpdate:inputModel": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isValidAge = $event))
            }, {
              "error-message": _withCtx(() => [
                _createVNode(_component_InlineError, {
                  "data-cy": "age-checkbox-errors",
                  message: _ctx.$t('form.validAgeCheckbox.error', {minAge: _ctx.minimumAge})
                }, null, 8, ["message"])
              ]),
              _: 1
            }, 8, ["labelText", "inputModel"]),
            (_ctx.isSubjectToGdpr)
              ? (_openBlock(), _createBlock(_component_BaseInputCheckbox, {
                  "data-cy": "email-checkbox",
                  key: "emailOptin",
                  inputName: "emailOptIn",
                  inputModel: _ctx.isEmailOptedIn,
                  labelText: _ctx.$t('form.emailOptinCheckbox.label'),
                  "onUpdate:inputModel": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isEmailOptedIn = $event))
                }, null, 8, ["inputModel", "labelText"]))
              : _createCommentVNode("", true),
            _createVNode(_component_BaseInputCheckbox, {
              "data-cy": "terms-checkbox",
              key: "terms",
              inputName: "termsAndPolicy",
              "validation-rules": "required",
              inputModel: _ctx.isTermsAgreed,
              "onUpdate:inputModel": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isTermsAgreed = $event))
            }, {
              "custom-label": _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('form.termsCheckbox.labelPrefix')) + " ", 1),
                _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('form.termsCheckbox.termsOfUse')), 1),
                _createTextVNode(" & "),
                _createElementVNode("a", { href: _ctx.privacyPolicyLink }, _toDisplayString(_ctx.$t('form.termsCheckbox.privacyPolicy')), 9, _hoisted_17)
              ]),
              "error-message": _withCtx(() => [
                _createVNode(_component_InlineError, {
                  "data-cy": "terms-checkbox-errors",
                  message: _ctx.$t('form.termsCheckbox.error')
                }, null, 8, ["message"])
              ]),
              _: 1
            }, 8, ["inputModel"]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_BaseButton, {
                class: "btn-primary",
                type: "submit",
                "data-cy": "continue-button",
                disabled: !meta.valid || !_ctx.birthDateValid || _ctx.waitingForApi
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.continueBtn')), 1)
                ]),
                _: 2
              }, 1032, ["disabled"])
            ])
          ], 40, _hoisted_2)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}